import { BoxProps } from 'grommet';
import { Right } from 'lib/api';
import { rightStatusTone } from 'src/utils/styling';
import { StatusPill } from '../StatusPill';
import { RightInfoCard } from './RightInfoCard';
import { RightInfoItem } from './RightInfoItem';
import { RightInfoRow } from './RightInfoRow';

export type BasicInformationProps = {
  background?: BoxProps['background'];
  right: Partial<Right>;
};

export const BasicInformation = ({ background, right }: BasicInformationProps) => {
  return (
    <RightInfoCard title="Basic Information" background={background}>
      <RightInfoRow>
        <RightInfoItem title="Description" value={right.description || 'Not specified'} />
        <RightInfoItem title="Type" value={right.rightType || 'Not specified'} />
        <RightInfoItem
          title="Status"
          value={
            right.status ? <StatusPill label={right.status} tone={rightStatusTone(right.status)} /> : 'Not specified'
          }
        />
        <RightInfoItem
          title="Commercials"
          value={right.commercials?.length ? right.commercials.map((c) => c.title).join(', ') : 'All Commercials'}
        />
      </RightInfoRow>
    </RightInfoCard>
  );
};
